<template>
  <div
    class="py-5 pl-5 flex flex-1 leading-4"
    :class="isActive ? 'bg-primary text-white': 'bg-white text-primary'"
    style="min-height: 90px"
  >
    <div
      v-show="customer && customer.id && customer.information.name"
      class="flex flex-1 items-center"
    >
      <router-link
        :to="{ name: 'customer.home' }"
        class="flex flex-1"
      >
        <CustomerSummary
          :customer="customer"
          :active="isActive"
          @mousedown="clicked"
        />
        <button
          v-if="!loading"
          class="h-full pl-1"
          :disabled="loading"
          @click="refresh"
        >
          <icon
            name="mdi-sync"
            :size="18"
            color="#FFFFFF"
          />
        </button>
        <BaseSpinner v-else size="button" color="white" class="h-full pl-1  cursor-not-allowed" />
      </router-link>
      <div class="flex justify-end pr-5">
        <CustomerCertificationHeader
          :customer="customer"
          class="self-end"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import CustomerCertificationHeader from '@/customer-certification/components/CustomerCertificationHeader.vue';
import CustomerSummary from '@/customer/components/customer-summary/CustomerSummary.vue';
import Customer from "@/customer/interfaces/Customer";
import Icon from "@/core/components/icon/Icon.vue";
import {mapActions} from "pinia";
import {usePatientStore} from "@/stores/patient.store";
import BaseSpinner from "@/core/components/base/spinner/BaseSpinner.vue";

export default defineComponent({
    name: 'CustomerHeaderInsured',
    components: {BaseSpinner, Icon, CustomerSummary, CustomerCertificationHeader},
    props: {
        customer: {
            type: Object as PropType<Customer>,
            required: true
        }
    },

    data() {
        return {
            loading: false
        };
    },

    computed: {
        isActive() {
            return this.$route.name !== 'customer.beneficiary'
                && this.$route.name !== 'customer.pet'
                && this.$route.name != 'customer.pet.create';
        }
    },

    methods: {
        ...mapActions(usePatientStore, ['load']),
        back() {
            this.$router.go(-1);
        },
        clicked() {
            if (this.$route.name === 'customer.home') {
                window.dispatchEvent(new Event('insured-clicked'));
            }
        },
        async refresh(e: Event) {
            this.loading = true;
            e.stopPropagation();
            e.preventDefault();
            await this.load(this.customer.id, true);

            this.loading = false;
        }
    }
});
</script>
